// extracted by mini-css-extract-plugin
export default {"root":"wa-button_root__Vhios"};